export default __webpack_public_path__ + "static/media/office_center.d5c75104.svg";